<template>
  <div style="background: #fff;height:auto;">
    <div style="margin:40px 0 0 30px;font-size:24px;font-weight:bold;color:#000;">Order History</div>
    <div style="margin:14px 0 0 30px;font-size:16px;color:#000;">
      <span>Account name: </span>
      <span>{{ accountName }}</span>
      <span style="margin-left:30px;">ID: </span>
      <span>{{ userId }}</span>
    </div>
    <div style="margin:28px 20px;">
      <el-table
          ref="multipleTable"
          :data="orderList"
          tooltip-effect="dark"
          style="width: 100%;">
          <el-table-column label="Order date/invoice date">
            <template slot-scope="scope">
              <p style="font-size:16px;color:#343434;">{{ scope.row.submittedTime }}</p>
            </template>
          </el-table-column>
          <el-table-column label="Order number/PO number">
            <template slot-scope="scope">
              <p style="font-size:16px;color:#343434;margin-bottom:10px;">{{ scope.row.orderNumber }}</p>
              <p style="font-size:16px;color:#343434;">{{ scope.row.poNumber }}</p>
            </template>
          </el-table-column>
          <el-table-column>
            <template slot-scope="scope">
              <div>
                <a><img @click="goCart" style="width:30px;height:28px;" src="../../assets/cart/cart_icon2.png"></a>
                <span style="margin:0 22px;">|</span>
                <a><img @click="goAftersales(scope.row)" style="width:23px;height:23px;" src="../../assets/cart/cart_icon3.png"></a>
                <span style="margin:0 22px;">|</span>
                <a href="mailto:service@kelliop.com?subject=Electronic%20quotation%20"><img style="width:27px;height:20px;" src="../../assets/cart/emil_icon.png"></a>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Status">
            <template slot-scope="scope">
              <p style="font-size:16px;color:#343434;">{{ scope.row.orderStatus }}</p>
            </template>
          </el-table-column>
          <el-table-column label="Order details">
            <template slot-scope="scope">
              <a @click="goDetail(scope.row)" style="font-size:16px;color:#00718c;">View Order History</a>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin:32px 0 32px 55px;">
          <a @click="goDelete" style="font-size:18px;color:#00718c;">Delete List</a>
        </div>
        <div style="width:100%;box-shadow: 0 5px 10px -5px rgba(111, 107, 97, 0.1);border-bottom:1px solid #f9f9f9;"></div>
    </div>
  </div>
</template>
<script>
    import { orderList, deleteList } from '@/api/Persona/index' ;
    export default {
        name: 'Orderhistory',
        components: {},
        data () {
            return {
              orderList: [],
              accountName: '',
              userId: '',
            }
        },
        methods: {
          getOrderList() {
              const params = {};
              orderList(params).then((res) => {
                console.log(res, 'orderList');
                this.orderList = res.list;
                this.userId = res.userId;
                this.accountName = res.accountName;
              });
          },
          goDetail(item) {
            this.$router.push({
              path: './orderDetail',
              query: { id: item.id }
            });
          },
          goDelete() {
            deleteList({}).then((res) => {
              console.log(res, 'deleteList');
              this.getOrderList();
            });
          },
          goAftersales(row) {
            this.$router.push({
              path: './afterSales',
              query: { id: row.id }
            });
          },
          goCart() {
            this.$router.push({name: "Cart"});
          }
        },
        mounted() {
          this.getOrderList();
        },
    }
</script>

<style scoped>
::v-deep .el-table th {
  background-color:#f5f5f5;
  height:48px;
  color:#b0b0b0;
  font-size:16px;
}
::v-deep .el-table thead {
  color:#b0b0b0;
  font-size:16px;
  font-weight:400;
}
</style>